import React from "react"
import { ElavonCardValidation } from "./elavonLB"
import Shift4 from "./shift4"
import { PCIPROXY } from "./pci-proxy"


export const CardValidation = ({ cardValidationInterface, guestValidationMaxRetry, isCardVerified, handleSetCardVerified, guestDetails, handleGoBack, handleCancel, handleNext, handleSkip }) => {


    return (
        cardValidationInterface == "ElavonLB" ?
            <ElavonCardValidation
                isCardVerified={isCardVerified}
                handleSetCardVerified={handleSetCardVerified}
                guestDetails={guestDetails}
                handleGoBack={handleGoBack}
                handleCustomCancelClick={handleCancel}
                handleNext={handleNext}
                handleSkip={handleSkip}
            />
            : cardValidationInterface == "Shift4" ?
                <Shift4
                    isCardVerified={isCardVerified}
                    guestValidationMaxRetry={guestValidationMaxRetry}
                    handleSetCardVerified={handleSetCardVerified}
                    guestDetails={guestDetails}
                    handleGoBack={handleGoBack}
                    handleCustomCancelClick={handleCancel}
                    handleNext={handleNext}
                    handleSkip={handleSkip}
                />
                :
                cardValidationInterface == "PCIPROXY" ?
                    <PCIPROXY
                        isCardVerified={isCardVerified}
                        handleSetCardVerified={handleSetCardVerified}
                        guestDetails={guestDetails}
                        handleGoBack={handleGoBack}
                        handleCustomCancelClick={handleCancel}
                        handleNext={handleNext}
                        handleSkip={handleSkip}
                    />
                    : null
    )
}